export const hasIdInArray = (array = [], findId) => array.some(({ id }) => id === findId);
